<template>
  <integration-call-rail is-onboarding-integration/>
</template>

<script>
import {defineComponent} from 'vue'
import IntegrationCallRail from "../../settings/integrations/IntegrationCallRail.vue";

export default defineComponent({
  name: "OnboardingStepCallRail",
  components: {IntegrationCallRail},
})
</script>

<style scoped lang="scss">

</style>
